import { memo } from "react";

export const IsRefundReturnDetails = memo(function IsRefundReturnDetails() {
  return null;
});
